class ScatterChart extends Chart {
  constructor(config) {
    super(config);
    this.requiredProps = ['container', 'data', 'xAxis', 'yAxis'];
    this.svg;
    this.x;
    this.y;
    this.tooltip = {};
    this.zeroLine = config.zeroLine || false;
  }

  createTooltip(tooltip, event, activeData, date) {
    const html = this.setTooltipHTML(activeData);

    tooltip
      .html(html)
      .style('opacity', 1)
      .style('left', `${event.pageX +15}px`)
      .style('top', `${event.pageY-15}px`);
  }

  // createTooltip(data, tooltipCard) {
  //     tooltipCard
  //       .style('left', d3.event.pageX + 'px')
  //       .style('top', d3.event.pageY - 28 + 'px')
  //       .style('opacity', 1)
  //       .html(this.setTooltipHTML([data]))
  // }

  /**
   * This method is used to remove an existing Heatmap tooltip
   * @return {object} [returns Heatmap]
   */
  removeTooltip(tooltipCard) {
    tooltipCard.style('opacity', 0);
    return this;
  }

  setTooltipHTML(data) {
    if ( data.length > 0 ) {
      let html = `<div class="ts-tooltip-title">${data[0].prettyDate}</div>`;
      data.forEach( d => {
        const legendStyle = d.hollow ? `background: none; border: 2px solid ${d.color}` : `background: ${d.color}`;
        html += `
          <div class="ts-tooltip-value-wrapper">
            <div class="ts-tooltip-legend" style="${legendStyle}"></div>
            <div class="ts-tooltip-value">${d[d.seriesField]}: ${d[this.yAxis.field].toFixed(1)} ${d[this.yAxis.unitsField]}</div>
          </div>`
      });
      return html;
    } else {
      const existingHTML = document.querySelector(`.tooltip-card-${this.container.replace('#','')}`).innerHTML;
      return existingHTML;
    }
  }

  /**
   * This method handles all of the logic surrounding creating the graph series
   * This method creates the tooltips, area, line, and point elements
   */
  createSeries() {
    const { width, height } = this.chartDimensions;
    const { svg, data, x, y } = this;
    const self = this;

    const xAxisField = this.xAxis.field || 'rdate';
    const yAxisField = this.yAxis.field || 'rvalue';
    const prettyDate = d3.timeFormat('%b %d, %Y');

    const line = this.createLine(xAxisField, yAxisField, x, y);

    if (this.zeroLine && y.domain()[1] > 0) {
      const zeroLine = svg.append('line').attr('class', 'zero-line');

      zeroLine
        .attr('x1', 0)
        .attr('x2', width)
        .attr('y1', y(0))
        .attr('y2', y(0))
        .style('stroke', '#333')
        .style('stroke-width', '2px')
        .style('opacity', 1);
    }

    if (this.series.length > 1) {
      this.series.map((s) => {
        const color = s.color || '#6464c1';
        this.data = this.data.map((d) => {
          if (d[s.field] === s.value && d[s.secondaryField] === s.secondaryValue) {
            Object.assign(d, {
              color,
              hollow: s.hollow,
              prettyDate: prettyDate(new Date(`${d[this.xAxis.field]} 00:00:00`)),
              seriesField: s.field,
              seriesValue: s.value,
              seriesSecondaryField: s.secondaryField,
              seriesSecondaryValue: s.secondaryValue,
            });
          } else if (d[s.field] === s.value) {
            Object.assign(d, { color, seriesField: s.field, seriesValue: s.value });
          }
          return d;
        });
        return [
          this.appendPointSeries(svg, data, [[s.field, s.value], [s.secondaryField, s.secondaryValue]], 'd3-point', x, y, s.color || color, s.hollow),
        ];
      });
    } else {
      const color = this.series[0].color || '#6464c1';
      const pointSeries = this.appendPointSeries(svg, data, [], 'd3-point', x, y, color, s.hollow, tooltipCard);
    }
    return this;
  } // createSeries()

  appendPointSeries(svg, data, filter, classList, x, y, color, hollow) {
    const self = this;
    const filteredData = data
      .filter(d => d[filter[0][0]] === filter[0][1])
      .filter(d => d[filter[1][0]] === filter[1][1]);

    if (hollow) {
      svg.selectAll(classList)
        .data(filteredData) // set data source
      .enter().append('circle')
        .on('mouseover', function(d) {
          // self.createTooltip(d, tooltipCard);
        })
        .on('mouseout', function(d) {
          // self.removeTooltip(tooltipCard);
        })
        .attr('r', 5.5) // dot radius
        .attr('cx', function(d) { return x(new Date(`${d[self.xAxis.field]} 00:00:00`)) }) // dot x placement
        .attr('cy', function(d) { return y(d[self.yAxis.field]); }) // dot y placement
        .attr('class', classList)
        .style('fill', `rgba(0,0,0,0)`)
        .style('stroke', color)
        .style('stroke-width', 2)
        .transition()
        .duration(1250)
        .style('opacity', 1);
    } else {
      svg.selectAll(classList)
        .data(filteredData) // set data source
      .enter().append('circle')
        .on('mouseover', function(d) {
          // self.createTooltip(d, tooltipCard);
        })
        .on('mouseout', function(d) {
          // self.removeTooltip(tooltipCard);
        })
        .attr('r', 5.5) // dot radius
        .attr('cx', function(d) { return x(new Date(`${d[self.xAxis.field]} 00:00:00`)) }) // dot x placement
        .attr('cy', function(d) { return y(d[self.yAxis.field]); }) // dot y placement
        .attr('class', classList)
        .style('fill', color)
        .transition()
        .duration(1250)
        .style('opacity', 1);
    }
  } // appendPointSeries()

  createOverlay() {
    const { width, height } = this.chartDimensions;
    const { svg, data, x, y } = this;
    const self = this;

    const datesArr = [...new Set(data.map(d => d.rdate))];
    let dataByDate = datesArr.map((d) => ({
      key: d,
      values: data.filter(dd => dd.rdate === d)
    }));

    if (document.querySelector(`.tooltip-card-${self.container.replace('#','')}`) !== null) {
      document.querySelector(`.tooltip-card-${self.container.replace('#','')}`).remove();
    }

    const tooltipCard = d3.select('body').append('div').attr('class', `tooltip-card tooltip-card-${self.container.replace('#','')}`);

    const rect = svg.append('rect')
        .attr('transform', 'translate(0,0)')
        .attr('class', 'overlay')
        .style('opacity', 0)
        .attr('width', width)
        .attr('height', height)
        .on('mousemove', function (d) {
          const mx = d3.mouse(this)[0];
          const mouseDate = moment(x.invert(mx));
          const roundedMouseDate = mouseDate.format('YYYY-MM-DD');

          const activeData = dataByDate
            .filter(d => d.key === roundedMouseDate);

          if (activeData.length > 0) {
            self.createTooltip(tooltipCard, d3.event, activeData[0].values)
          }
        })
        .on('click', function (d) {
          const mx = d3.mouse(this)[0];
          const mouseDate = moment(x.invert(mx));
          const roundedMouseDate = mouseDate.format('YYYY-MM-DD');

          const activeData = dataByDate
            .filter(d => d.key === roundedMouseDate);

          if (activeData.length > 0) {
            self.createTooltip(tooltipCard, d3.event, activeData[0].values)
          }
        })
        .on('mouseout', function() {
          self.removeTooltip(tooltipCard);
        });
  }

  draw() {
    this
      .validateConfig()
      .createSVG()
      .createScales()
      .createAxis('x', this.xAxis.field, 'x-axis axis')
      .createAxis('y', this.yAxis.field, 'y-axis axis')
      .createSeries()
      .createOverlay();
    return this;
  } // draw()
}
